// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ArrowSmallDownRightIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="ArrowSmallDownRightIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M13 7v6H7v-1.5h4.5V7z" />
      <path d="M11.5 12.5 7.257 8.257l1.061-1.06 4.243 4.242z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ArrowSmallDownRightIcon = /* @__PURE__ */ Object.assign(
  ArrowSmallDownRightIconComponent,
  { displayName: 'ArrowSmallDownRightIcon' },
);
